import Pagination from "../../component/Pagination";

import { formatCountryDate } from "../../Services/countryTime";
export default function CustomerTable({
  currentItems,
  indexOfFirstItem,  
  currentPage,
  totalPages,
  itemsPerPage,
  filteredEventData,
  handlePageChange,
  loading, // ✅ new prop
}) {
  console.log("filteredEventData", filteredEventData);
  
  return (
    <div className="tableheader w-100">   
         {/* Show selected event name and date at the top */}
     {filteredEventData.length > 0 && (
  <div className="selected-event-info mb-3 text-center text-dark d-flex flex-wrap gap-3">
    <div className="eventname">
      <strong>Event Name:</strong> {filteredEventData[0].Title}
    </div> 

    <div className="eventdate">
      <strong>Date:</strong>{" "}
      {(() => {
        const d = new Date(filteredEventData[0].event_date);
        return formatCountryDate(d).replace(/\//g, "-");
      })()}
    </div>

    <div className="eventdate">
      <strong>Time:</strong>{" "}
      {(() => {
        const formatTime = (timeStr) => {
          if (!timeStr) return "";
          const [hour, minute] = timeStr.split(":");
          const date = new Date();
          date.setHours(hour, minute);
          return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true });
        };
        return `${formatTime(filteredEventData[0].StartTime)} - ${formatTime(filteredEventData[0].EndTime)}`;
      })()}
    </div>
  </div>
)}

      <div className="event-detailstable" style={{ minHeight: "initial"}}>
      <table className="table">
        <thead>
          <tr>
            <th width="10px">Sr. No.</th>
            <th>Name</th>
            <th>Email</th>
            <th>Mobile no.</th>
            <th>Organization Name</th>
            <th>Tally Number</th>
            <th width="80px">Participants</th>
            <th width="80px">Registration Date</th>
            <th>Meet Type</th> 
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={10} align="center">
                Loading...
              </td>
            </tr>
          ) : currentItems.length > 0 ? (
            currentItems.map((customer, index) => (
              <tr key={customer.id || customer.tallynumber || index}>
                <td align="center">{indexOfFirstItem + index + 1}</td>
                <td>{customer.name}</td>
                <td>{customer.email}</td>
                <td>{customer.mobile}</td>
                <td>{customer.organization}</td>
                <td>{customer.tallynumber}</td>
                <td className="text-center">{customer.NoOfParticipants}</td>
                <td align="center">
                  {formatCountryDate(customer.registration_date)
                    .replace(/\//g, "-")}
                </td>
                <td style={{ textAlign: "center" }}>
                  {customer.ModeOfMeeting && (
                    <span
                      className={`status-badge ${
                        customer.ModeOfMeeting?.toLowerCase() === "online meeting"
                          ? "status-active"
                          : "status-deactive"
                      }`}
                    >
                      {customer.ModeOfMeeting}
                    </span>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={10} align="center">No data found</td>
            </tr>
          )}
        </tbody>
      </table>    
      </div>
         {filteredEventData.length > itemsPerPage && !loading && (
        <div className="mt-3">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      )}
    </div>   
  );
}
